import {Brick, registerBrick, Query} from 'olympe';
import {tagToDisplayER} from '../tagTransforms';
import {PurchaseRequest} from '../../models/PurchaseRequest';
import PurchaseRequestDM from '../../models/cloudobjects/PurchaseRequestDM';

/**
 * This brick takes a tag, and transform it into a EPR-ID
 */
export default class TagToEPRID extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} tAG
     * @param {function(string)} setEPRID
     */
    update($, [tag], [setEPRID]) {
        if (!tag) return;
        Query
            .fromTag(tag, PurchaseRequestDM)
            .execute()
            .then((queryResult) => {
                const first = queryResult.getFirst();

                let EPRId = null;
                if (first !== null) {
                    EPRId = new PurchaseRequest(first.getJson()).EPRId;
                }
                setEPRID(EPRId || tagToDisplayER(tag));
            });
    }
}

registerBrick('018a654bcbee82e6452b', TagToEPRID);
